module.exports = __webpack_public_path__ + "static/img/banner-bg.7c3a956a.png";